export default {
  SAVE: 'userInfo/SAVE',
  DELETE: 'userInfo/DELETE'
}
